import getDashboard from './dashboard';
import getCustomer from './customer';
import salesRecord from './salesRecord';
import getUsersManagement from './users';
import getMasterDataManagement from './masterDataManagement';
import dailyPayoutRecords from './dailyPayoutRecords';
import referralDetails from './referralDetails';
import packageItem from './package';
import expensesRecords from './expensesRecords';
import adjustment from './adjustment';
import customerTransactions from './customerTransactions';
import salesLockRecord from './salesLockRecord';
import binaryIncomeDetails from './binaryIncomeDetails';
import sContent from './sContent';
import drivers from './drivers';
import addresses from './addresses';
import lockSalesProfit from './lockSalesProfit';
import transfer from './transfer';
import missionClaims from './missionclaims';
import ambassadorLevel from './ambassadorLevel';
import getAmbassadorLevel from './ambassadorLevel';
import getCustomerTasklistExpiration from './customerTasklistExpiration';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [
        getDashboard(),
        getCustomer(),
        salesRecord,
        getMasterDataManagement(),
        dailyPayoutRecords,
        packageItem,
        expensesRecords,
        referralDetails,
        salesLockRecord,
        adjustment,
        customerTransactions,
        binaryIncomeDetails,
        sContent,
        getUsersManagement(),
        drivers,
        addresses,
        lockSalesProfit,
        transfer,
        missionClaims,
        getAmbassadorLevel(),
        getCustomerTasklistExpiration()
    ]
};

export default menuItems;
